import React, {useState, useEffect} from 'react';
import WeatherForcastDay from "./WeatherForcastDay"
import "./WeatherForcast.css";
import axios from 'axios';
export default function WeatherForcast(props){
    let [loaded, setLoaded] = useState(false);
    let [forecast, setForecast] = useState(null);

    useEffect(()=> {
        setLoaded(false);
    }, [props.coordinates])
   
    function handleResponse(response){
         console.log(response.data)
          setForecast(response.data.daily)
          setLoaded(true)
    }

        if (loaded) {
            return (
               <div className="WeatherForecast">
                  <div className="row" >
             
                   {forecast.map(function(dailyForecast ,index){
                    if (index < 5) {
                       return (
                        <WeatherForcastDay data={dailyForecast} key={index} />
                     )
                    } else {
                        return null
                    }
                     
                   })}
                  
                  </div>
               </div>
            )   
        } else {
            const apiKey = "02ccbb242b049d619a5146ftbb339do7";
            const longitude = props.coordinates.longitude
            const latitude = props.coordinates.latitude
            const apiUrl =`https://api.shecodes.io/weather/v1/forecast?lon=${longitude}&lat=${latitude}&key=${apiKey}`
            axios.get(apiUrl).then(handleResponse)

            return null
        }    
}
